import component from './main.vue'
export default component
